<script lang="ts" setup>
definePageMeta({
  layout: 'auth',
  middleware: ['auth-route']
});

useHead({
  title: 'Play'
});
</script>

<template>
  <Container class-name="h-full flex justify-center items-center py-10">
    <PlayHandleAnonymouslyV2 />
  </Container>
</template>

<style lang="scss" scoped></style>
